module.exports = __webpack_public_path__ + "static/img/T250310_1.05723a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T250310_1.png
// module id = Aej/
// module chunks = 1